<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" sm="12">
                <div class="custom-question-msg">
                    Test cannot be created for following pattern because there are insufficient questions
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "customizedTestsSubPopup",
    props: ["onClose", "status", "data", "onCustomizeClick"],
    data() {
        return {
            dummyOptions: [],
            dummyOptionsABC: [],
            dummyOptionsPQR: [],
            subQuestionLength: 0,
            disableCreateTest: false,
            showCustomizeSyllabus: false,
        };
    },
    mounted() {},
};
</script>
